<template>
  <div>
    <div id="atlasChart"></div>
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";
import * as  echarts from "echarts";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
    };
  },
  mounted() {
    PageHelper.Init(this);
    this.montheahcrt();
  },
  methods: {
    montheahcrt() {
       // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("atlasChart"));
     let option = {
        title: {
          
        },
        tooltip: {},
        animationDurationUpdate: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            type: "graph",
            layout: "none",
            symbolSize: 50,
            //设置缩放
            roam: false,
            label: {
              show: true,
            },
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 12,
            },
            data: [
              {
                name: "本店",
                x: 0,
                y: 0,
              },
              {
                name: "TOP 1",
                x: 100,
                y: 0,
              },
              {
                name: "TOP 2",
                x: 80.9,
                y: 58.78,
              },
              {
                name: "TOP 3",
                x: 30.9,
                y: 95.11,
              },
              {
                name: "TOP 4",
                x: -30.9,
                y: 95.11,
              },
              {
                name: "TOP 5",
                x: -80.9,
                y: 58.78,
              },
              {
                name: "TOP 6",
                x: -100,
                y: 0,
              },
              {
                name: "TOP 7",
                x: -80.9,
                y: -58.78,
              },
              {
                name: "TOP 8",
                x: -30.9,
                y: -95.11,
              },
              {
                name: "TOP 9",
                x: 30.9,
                y: -95.11,
              },
              {
                name: "TOP 10",
                x: 80.9,
                y: -58.78,
              },
            ],
            // links: [],
            links: [
              {
                source: "TOP 1",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "32",
                },
              },
              {
                source: "TOP 2",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "36",
                },
              },
              {
                source: "TOP 3",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "44",
                },
              },
              {
                source: "TOP 4",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "21",
                },
              },
              {
                source: "TOP 5",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "20",
                },
              },
              {
                source: "TOP 6",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "33",
                },
              },
              {
                source: "TOP 7",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "60",
                },
              },
              {
                source: "TOP 8",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "58",
                },
              },
              {
                source: "TOP 9",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "95",
                },
              },
              {
                source: "TOP 10",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "11",
                },
              },
              {
                source: "本店",
                target: "TOP 1",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "16",
                },
              },
              {
                source: "本店",
                target: "TOP 2",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "18",
                },
              },
              {
                source: "本店",
                target: "TOP 3",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "10",
                },
              },
              {
                source: "本店",
                target: "TOP 4",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "8",
                },
              },
              {
                source: "本店",
                target: "TOP 5",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "10",
                },
              },
              {
                source: "本店",
                target: "TOP 6",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "16",
                },
              },
              {
                source: "本店",
                target: "TOP 7",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "13",
                },
              },
              {
                source: "本店",
                target: "TOP 8",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "14",
                },
              },
              {
                source: "本店",
                target: "TOP 9",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "11",
                },
              },
              {
                source: "本店",
                target: "TOP 10",
                lineStyle: {
                  curveness: 0.15,
                },
                label: {
                  show: true,
                  formatter: "10",
                },
              },
            ],
            lineStyle: {
              opacity: 0.9,
              width: 2,
              curveness: 0,
            },
          },
        ],
      };
      myChart.setOption(option)
    },
  

  },
};
</script>
<style scoped>
#atlasChart {
  width: 760px;
  height: 600px;
  background: rgba(242, 242, 242, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/Test.vue